<template>
    <div class="dml-content" data-t="24">
        <div class="dml-content__item" v-for="contentItem in contentItems">
            <component v-bind:is="contentItem.type"
                       v-bind="contentItem" />
        </div>
    </div>
</template>
<script>
    import BannerComponent from './banner-component';
    import ProductsBannerComponent from './products-banner-component';
    import ArticleHomeComponent from './article-home-component';
    import ThumbArticleComponent from './thumb-article-component';
    import HeadingComponent from './heading-component';
    import TopProductsComponent from './top-products-component';
    import ScrollableBannersComponent from './scrollable-banners-component';

    export default {
        name: 'dm-adjustable-content',
        components: {
            'dm-banner-component': BannerComponent,
            'dm-products-banner-component': ProductsBannerComponent,
            'dm-article-component': ArticleHomeComponent,
            'dm-thumb-article-component': ThumbArticleComponent,
            'dm-heading-component': HeadingComponent,
            'dm-top-products-component': TopProductsComponent,
            'dm-scrollable-banners-component': ScrollableBannersComponent,
        },
        props: {
            contentItems: {
                type: Array,
                required: true
            }
        }
    };
</script>
